<template>
  <v-row align="center" justify="center" data-matomo-mask>
    <div class="pa-3 d-flex">
      <v-icon class="mr-4" v-if="$vuetify.breakpoint.mdAndUp">fas fa-user</v-icon>
      <span v-if="this.$vuetify.breakpoint.smAndDown" class="mr-1">{{ $t('welcome') }}</span>
      <span>{{ debtor.firstName }} {{ debtor.lastName }}</span>
    </div>
    <div class="pa-3 d-flex" v-if="email != null && $vuetify.breakpoint.mdAndUp">
      <v-icon class="mr-2">fas fa-envelope</v-icon>
      <span>{{ email.emailAddress}}</span>
    </div>
    <div class="pa-3 d-flex" v-if="phone != null && $vuetify.breakpoint.mdAndUp">
      <v-icon class="mr-2">fas fa-phone</v-icon>
      <span>{{ phone.number}}</span>
    </div>
  </v-row>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        debtor: 'debtor'
      }),
      email: function () {
        var emails = null
        if (this.debtor.contactInformation !== null) {
          emails = this.debtor.contactInformation.emails.length ? this.debtor.contactInformation.emails[0] : null
        }
        return emails
      },
      phone: function () {
        var phones = null
        if (this.debtor.contactInformation !== null) {
          phones = this.debtor.contactInformation.phones.length ? this.debtor.contactInformation.phones[0] : null
        }
        return phones
      }
    }
  }
</script>
